import Dinero from 'dinero.js'

export const getDisplayPrice = (amount: number, currency: string) => {
  return Dinero({ amount: amount, currency: currency }).toFormat('$0,0.00')
}